import { add, durationsToDateAdapter } from '@sequencehq/utils/dates'
import {
  CubeReducerState,
  PhaseDuration
} from 'modules/Cube/domain/cube.domain.types'
import { getOriginalScheduleDuration } from 'modules/Cube/domain/postActionStages/queries/getContractDuration'
import {
  getAmendedScheduleEndDates,
  getIsAmendedScheduleCovered
} from 'modules/Cube/domain/postActionStages/queries/getIsAmendedScheduleCovered'

/**
 * The duration a new phase needs for the quote's phases to add up to the
 * amended schedule's length. Undefined when there's no such duration: the
 * quote isn't an amendment, a phase has no end, or the phases already cover
 * the amended schedule.
 *
 *   start ... phases end | +1d ... remaining ... | amended end
 */
export const getAmendmentRemainingDuration = (
  prevState: Pick<CubeReducerState, 'data'>
): PhaseDuration | undefined => {
  if (prevState.data.quote.dealType !== 'AMENDMENT') {
    return
  }

  const originalPhases = prevState.data.quote.amendment?.original.phases ?? []

  if (!originalPhases.length) {
    return
  }

  if (!getOriginalScheduleDuration(originalPhases)) {
    return 'OPEN_ENDED'
  }

  const endDates = getAmendedScheduleEndDates(prevState)

  if (!endDates || getIsAmendedScheduleCovered(prevState)) {
    return
  }

  return durationsToDateAdapter.toDuration(
    add(endDates.phasesEndDate, { days: 1 })
  )(endDates.amendedEndDate)
}
